import React, { useEffect, useState } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Image from '~components/atoms/Image';
import Table from '~components/molecules/Table';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import UtilFunctions from '~utils/functions';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { FundTypeEnum } from '~utils/enums';

const InventoryDeliveredTable = () => {
    const dispatch = useAppDispatch();

    const {
        Misc: {
            dateTimeFormat,
        },
    } = UtilFunctions;

    const isLoading = useAppSelector(state => state.gold.loadings.getGoldInventoryReportDeliveredListing);
    const inventoryDeliveredListingIndex = useAppSelector(state => state.gold.goldInventoryReport.inventoryDelivered.index);
    const inventoryDeliveredListing = useAppSelector(state => state.gold.goldInventoryReport.inventoryDelivered.data);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    useEffect(() => {
        dispatch(combinedActions.goldGetGoldInventoryReportDeliveredListingAttempt());
    }, [inventoryDeliveredListingIndex]);

    const tableHeader = [
        'IMAGE',
        'PRODUCT NAME',
        'DELIVERED TO',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL GOLD WEIGHT (g)',
        'FUND TYPE',
        'RECEIVED AT',
    ];

    const tableBody = inventoryDeliveredListing.map(inventory => {
        const {
            transferId,
            product,
            to,
            serialNumbers,
            quantity,
            fundType,
            totalGoldWeight,
            createdAt,
        } = inventory;

        const massagedSerialNumbers = serialNumbers.map(serial => serial.serialNo).filter(item => item);

        const handleViewSerialNo = () => {
            setIsSerialNoModalOpen(true);
            setSerialNoList(massagedSerialNumbers);
        };

        const renderSerialNo = () => (
            <ActionButton
                key={transferId}
                label='View'
                onClick={() => handleViewSerialNo()}
            />
        );

        return [
            <Image
                key={transferId}
                src={product.image || ''}
                width={40}
                height={40}
            />,
            product.productName,
            to.branchName,
            renderSerialNo(),
            quantity,
            totalGoldWeight,
            FundTypeEnum[fundType],
            dateTimeFormat(createdAt),
        ];
    });

    return (
        <>
            <Table
                isLoading={isLoading}
                header={tableHeader}
                body={tableBody}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </>
    );
};

export default InventoryDeliveredTable;
